// Copyright (C) 2020 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export const BLANK_CHECKBOX = 'check_box_outline_blank';
export const CHECKBOX = 'check_box';
export const INDETERMINATE_CHECKBOX = 'indeterminate_check_box';

export const EXPAND_DOWN = 'expand_more';
export const EXPAND_UP = 'expand_less';

export const STAR = 'star';
export const STAR_BORDER = 'star_border';
